import { messages } from "@components/Intl/messages"
import { ArticleCombinationQuery, ArticleQuery } from "@generated"
import { getPageByUrlSlug } from "@lib/kontent"
import { CollectionDetailPage as CollectionDetailModel } from "@lib/kontent/models-deprecated/collection_detail_page"
import mustache from "mustache"

type Args = {
  item:
    | ArticleCombinationQuery["choicesArticleCombination"]
    | ArticleQuery["choicesArticle"]
  urlSlug: string
  lang: string
}

export async function getDynamicSeoDescription({
  item,
  urlSlug,
  lang,
}: Args): Promise<string | null> {
  const content = (await getPageByUrlSlug({
    type: "collection_detail_page",
    urlSlug,
    lang,
  })) as CollectionDetailModel

  let description = null
  if (content.productDetailSeoDescription) {
    mustache.escape = (value) => value
    description = mustache.render(content.productDetailSeoDescription.value, {
      name: item.name,
      style: messages[lang].properties.style.options[item.style],
      material: messages[lang].properties.material.options[item.material],
    })
  }
  return description
}
